import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { JudgeForm } from '../models/judgeForm.model';
import { USER_API_ENDPOINT } from './../config';

@Injectable({
  providedIn: 'root',
})
export class JudgeFormService {

  constructor(
    private http: HttpClient,
  ) { }


  getJudgeForm(id: string): Observable<any> {
    return this.http.get(USER_API_ENDPOINT + '/judgeForm/user/' + id).pipe(
      map(res => res)
    );
  }

  createJudgeForm(judgeForm: JudgeForm): Observable<any> {
    return this.http.post(USER_API_ENDPOINT + '/judgeForm', judgeForm).pipe(
      map(res => res)
    )
  }

  updateJudgeForm(judgeForm: JudgeForm): Observable<any> {
    return this.http.put(USER_API_ENDPOINT + '/judgeForm', judgeForm).pipe(
      map(res => res)
    )
  }

  isJudgeForm(): Observable<any> {
    return this.http.get(USER_API_ENDPOINT + '/judgeForm/is-filled').pipe(
      map(res => res)
    );
  }

  getMyJudgeForm(): Observable<any> {
    return this.http.get(USER_API_ENDPOINT + '/judgeForm/').pipe(
      map(res => res)
    );
  }

  getJudgeForms(): Observable<any> {
    return this.http.get(USER_API_ENDPOINT + '/judgeForm/all').pipe(
      map(res => res)
    );
  }

  exportExcel(): Observable<any> {
    return this.http.post(USER_API_ENDPOINT + '/judgeForm/excel-list', null).pipe(
      map(res => res)
    )
  }

}
